import { CKField, CKMultiPicker, CKSelect } from 'clearkit';

export default function PredicateSelector({
  options,
  onSelectedItemsChange,
  selectedItems,
  typeName,
  placeholder,
  icon,
  style,
}) {
  const [isSelectAll, setIsSelectAll] = useState(!selectedItems?.length);

  const selectOptions = {
    any: {
      value: 'any',
      label: `Any ${typeName}`,
    },
    specific: {
      value: 'specific',
      label: `A specific ${typeName}`,
    },
  };

  const selected = selectOptions[isSelectAll ? 'any' : 'specific'];

  const selectedOptions = options.filter(
    ({ value }) => selectedItems.indexOf(value) > -1,
  );

  return (
    <div className="flex w-full gap-4" style={style}>
      <CKField className="block w-2/5" label="">
        <CKSelect
          items={Object.values(selectOptions)}
          itemToString={({ label }) => label}
          leftIcon={icon}
          onSelectedItemChange={({ selectedItem }) => {
            const all = selectedItem.value === 'any';
            setIsSelectAll(all);

            if (all && onSelectedItemsChange) {
              onSelectedItemsChange([]);
            }
          }}
          selectedItem={selected}
        />
      </CKField>
      <CKField className="flex-grow block w-3/5" label="">
        <CKMultiPicker
          isDisabled={isSelectAll}
          items={options}
          itemToString={(item) => item?.label}
          onSelectedItemsChange={({ selectedItems }) => {
            onSelectedItemsChange &&
              onSelectedItemsChange(selectedItems.map(({ value }) => value));
          }}
          placeholder={placeholder}
          selectedItems={selectedOptions}
        />
      </CKField>
    </div>
  );
}
